export const createDynamicListReq = (objects, mapData) => {
  let values = []
  objects?.forEach((obj) => {
    let inputValue = mapData.get(obj.id)
    let moreInputs = []

    obj.moreInputs?.forEach((item) => {
      moreInputs.push(mapData.get(item.id))
    })

    let childs = []
    if (obj.childs?.length > 0) {
      childs = createDynamicListReq(obj.childs, mapData)
    }

    inputValue['moreInputs'] = moreInputs
    inputValue['childs'] = childs

    values.push(inputValue)
  })

  return values
}

export const setValueDynamicToReq = (objects, data) => {
  let values = []
  objects?.forEach((obj) => {
    let res = { refId: obj.id, result: data[`${obj.id}`] || null }

    values.push(res)

    obj.moreInputs?.forEach((item) => {
      values.push({ refId: item.id, result: data[`${item.id}`] || null })
    })

    let childs = []
    if (obj.childs?.length > 0) {
      childs = setValueDynamicToReq(obj.childs, data)
      childs.forEach((e) => {
        values.push(e)
      })
    }
  })

  return values
}

export const setValueDynamicToReqByName = (objects, data) => {
  let values = []
  objects?.forEach((obj) => {
    let res = { refId: obj.name, result: data[`${obj.name}`] || null }

    values.push(res)

    obj.moreInputs?.forEach((item) => {
      values.push({ refId: item.name, result: data[`${item.name}`] || null })
    })

    let childs = []
    if (obj.childs?.length > 0) {
      childs = setValueDynamicToReq(obj.childs, data)
      childs.forEach((e) => {
        values.push(e)
      })
    }
  })

  return values
}
